import { intlTag } from '../i18n/locales';
import { PRICING_PLANS } from '../config/pricing';

/**
 * Whether these AI Agent numbers (/usage's ai_agent_projects) are the free plan's. The free plan has
 * no AI video since 2026-10-27, so a wall on it names no date. The app tells the free plan by
 * plan_limit, as the API keeps it.
 */
export function onFreeVideoPlan(usage) {
  return Boolean(usage) && usage.plan_limit === PRICING_PLANS.free.aiAgentVideos;
}

/**
 * Whether an account out of AI videos is sold its next one at Generate (FirstVideoOffer: Pro or a
 * pack, the video starting by itself after paying) instead of meeting an "out of videos" wall. Every
 * free-plan account is: the free plan has no AI video since 2026-10-27. Read from `free_plan` too,
 * not only `no_free_video`, so a page in front of an API from before that change still sells the
 * video (2026-10-27: that pair showed free accounts "0 of 0 used, you get more on November 1").
 */
export function sellsNextVideo(metrics) {
  const usage = metrics?.ai_agent_projects;
  if (!usage || usage.limit === 'Unlimited') return false;
  return Boolean(usage.no_free_video || metrics.free_plan);
}

/** The out-of-videos words for a wall: the free plan's (no date), or a plan's with the day it renews. */
export function videoWallBody(t, usage, renewsOn) {
  if (onFreeVideoPlan(usage)) return t('aiAgentPage.limitBodyFree');
  return renewsOn
    ? t('aiAgentPage.limitBody', { used: usage.used, limit: usage.limit, date: renewsOn })
    : t('aiAgentPage.limitBodyNoDate', { used: usage.used, limit: usage.limit });
}

// Within this long of the renewal, the time is said too
const SOON_MS = 36 * 60 * 60 * 1000;

/**
 * When the plan's videos come back, in the reader's own clock: the moment after the period ends.
 * A month ends at midnight UTC, which is the evening before in the Americas, so on the last
 * day "you get more on 30 September" was read on 30 September. Close to it, the time is said.
 */
/** A time the API sends without a zone ("2026-09-30T23:59:59") is UTC, not the reader's clock. */
export function parseUtc(value) {
  if (!value) return null;
  const text = String(value);
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(text) ? text : `${text}Z`);
}

export function renewalLabel(periodEnd, locale, now = new Date()) {
  const end = parseUtc(periodEnd);
  if (!end || Number.isNaN(end.getTime())) return null;
  const at = new Date(end.getTime() + 1000);
  const soon = at.getTime() - now.getTime() < SOON_MS;
  return at.toLocaleString(intlTag(locale), soon
    ? { day: 'numeric', month: 'long', hour: 'numeric', minute: '2-digit' }
    : { day: 'numeric', month: 'long' });
}
